module.exports = __webpack_public_path__ + "img/wp_theme.52652aeb.gif";